import { Component, Input, OnInit } from '@angular/core';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { Microphone } from 'src/app/shared/models/microphone.model';

@Component({
  selector: 'app-microphone-bar',
  templateUrl: './microphone-bar.component.html',
  styleUrls: ['./microphone-bar.component.scss'],
  providers: [
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: {
        touchGestures: 'off',
      },
    },
  ],
})
export class MicrophoneBarComponent {
  @Input() microphones: Microphone[] = [];
  values: any;
}
